import * as Yup from 'yup';
import moment from 'moment';

// W-0600 — filtros do Relatório de Digitalizações (migração uRelDigitalizacao.pas).
// dataInicio/dataFim obrigatórios; intervalo coerente (início <= fim).
export const filtrosSchema = Yup.object().shape({
  dataInicio: Yup.date()
    .typeError('Data inicial inválida.')
    .required('Data inicial deve ser informada.'),
  dataFim: Yup.date()
    .typeError('Data final inválida.')
    .required('Data final deve ser informada.')
    .test(
      'ini-menor-fim',
      'Data inicial deve ser menor ou igual a data final.',
      function (v) {
        const ini = this.parent && this.parent.dataInicio;
        if (!ini || !v) return true;
        return moment(ini).isSameOrBefore(moment(v), 'day');
      }
    ),
  ordenacao: Yup.string()
    .oneOf(['nome', 'qtde_asc', 'qtde_desc'])
    .required('Ordenação deve ser informada.'),
  detalhe: Yup.boolean(),
});
